// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6cPTc","outlined":"Button_outlined__M09WI","red":"Button_red__U7xLU"};